import AddButton from "@/components/common/AddButton"
import SortingTableTitle from "@/components/common/SortingTableTitle"
import ListActionLine from "@/components/common/ListActionLine"
import Popup from "@/components/common/Popup"

import formFilterData from "@/components/mixins/form-filter-data"
import formFields from "@/components/mixins/form-fields"
import message from "@/components/mixins/message"
import popup from "@/components/mixins/popup"
import userSettings from "@/components/mixins/user-settings"
import exportCsv from "@/components/mixins/exportCsv"

export default {
	components: {
		Popup,
		ListActionLine,
		SortingTableTitle,
		AddButton
	},
	mixins: [formFilterData, message, formFields, popup, userSettings, exportCsv],
	data() {
		return {
			dataLoaded: false,
			entitiesKey: null,
			entities: [],
			selectedEntities: [],
			formFieldsDefaults : [],
		}
	},
	created(){
		this.formFieldsDefaults = {...this.formFields};
	},
	computed: {
		multipleActionOptions() {
			let options = [
				{value: 'choose', text: this.$gettext('Vyberte akci')},
				{value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
			]
			if(this.$_updateActionAllowed){
				options.push({value: 'activate', text: this.$gettext('Aktivovat')});
				options.push({value: 'deactivate', text: this.$gettext('Deaktivovat')});
			}
			if(this.$_deleteActionAllowed){
				options.push({value: 'delete', text: this.$gettext('Smazat')},);
			}

			return options;
		},
		ownersSelectedOperators() {
			if (this.$_loggedUser_canChangeOperator) {
				return this.getOwnerSettingByKey('selected-operator-id');
			}
			return null
		},
		filteredSelectedEntities() {
			let filteredAndSelected = []
			this._.forEach(this.entities, function (filteredEntity) {
				if (this._.includes(this.selectedEntities, String(filteredEntity['id']))) {
					filteredAndSelected.push(String(filteredEntity['id']))
				}
			}.bind(this))

			return filteredAndSelected
		},
		csvHeaders(){
			return {};
		}
	},
	watch: {
		formFields: {
			handler() {
				this.saveFilterValues()
				this.getEntities()
			},
			deep: true
		},
		ownersSelectedOperators() {
			this._beforeOwnerOperatorChange();
			this.getEntities()
		}
	},
	methods: {
		createdInit() {
			this.keepOffset = true
			if (this.loadDefaults() === false) {
				this.getEntities()
			}
		},
		saveFilterValues() {
			this.saveSearch(this.formFields.search)
		},
		toggleSelectAll(value) {
			if (value) {
				this.entities.forEach(function (entity) {
					this.selectedEntities.push(String(entity.id));
				}.bind(this))
			}else{
				this.selectedEntities = [];
			}
		},
		select(e) {
			if (e.target.checked) {
				this.selectedEntities.push(String(e.target.value))
			} else {
				const index = this.selectedEntities.indexOf(String(e.target.value))
				if (index > -1) {
					this.selectedEntities.splice(index, 1)
				}
			}
		},
		executePopupAction(value) {
			if (value === true) {
				if (this._.includes(['delete', 'delete-multi'], this.getPopupAction)) {
					this.deleteEntity(this.getPopupId, false)
				}
			}
			this.hidePopup()
		},
		runMultipleAction(action, activeKey = 'active') {
			let params = {}
			if (action === 'activate') {
				params[activeKey] = true
				this.updateEntity({'id': this.filteredSelectedEntities.join(), 'params': params})
			}
			if (action === 'deactivate') {
				params[activeKey] = false
				this.updateEntity({'id': this.filteredSelectedEntities.join(), 'params': params})
			}
			if (action === 'delete') {
				this.deleteEntity(this.filteredSelectedEntities.join())
			}
			if (action === 'exportCsv'){
				this._exportCsv();
			}
		},
		getEntities() {
			let formFields = this._processFormFields(this.getFormFields());
			formFields = this._beforeGetEntitiesProcess(formFields);
			this.setLoadingMessage()
			this._processGetEntitiesResponse(this.entityService.getEntities(formFields))
		},
		_beforeGetEntitiesProcess(formFields){
			return formFields;
		},
		_processFormFields(formFields) {
			if(this.$_get_section_type(this.$route.meta.sectionName) != 'global_only' && !formFields.hasOwnProperty('id_selected_operator')) {
				formFields['id_selected_operator'] = this.$store.getters.getSelectedOperatorId
			}

			return formFields
		},
		_processGetEntitiesResponse(response) {
			response.then(data => {
                this.dataLoaded = true;
				this.entities = data[this.entitiesKey !== null ? this.entitiesKey : this.moduleName]
				this.totalCount = Number(data['totalCount'])
				this._afterGetEntitiesActions(data);
				this.emptyMessage()
			})
				.catch(error => {
					this.setErrorMessage(this._processListErrorMessage(error))
				})
		},
		updateEntity(data) {
			this.entityService.updateEntity(data.id, data.params)
				.then(() => {
					this.setSuccessMessage()
					this.keepOffset = true
					this.getEntities()
				})
				.catch(error => {
					this.setErrorMessage(this._processListErrorMessage(error))
				})
		},
		deleteEntity(id, showPopup = true) {
			if (showPopup) {
				if (this._.includes(id, ',')) {
					this.showPopup(id, 'delete-multi', 'delete-multi')
				} else {
					this.showPopup(id, 'delete', 'delete')
				}
			} else {
				this.entityService.deleteEntity(id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
					.then(() => {
						this.setSuccessMessage(this.$gettext('Smazáno'));
						this.selectedEntities = []
						this.keepOffset = true
						this.getEntities()
						this._afterDeleteActions()
					})
					.catch(error => {
						this.setErrorMessage(this._processListErrorMessage(error))
					})
			}
		},
		_afterDeleteActions() {
			// implement when needed
		},
		_processListErrorMessage(error) {
			return error['error_message']
		},

		_beforeOwnerOperatorChange(){

		},

		_exportCsv(){
			this.setLoadingMessage()
			let formFields = this._processFormFields(this.getFormFields());
			delete formFields.limit;
			delete formFields.offset;
			this._processGetEntitiesCsvResponse(this.entityService.getEntities(formFields), this.csvHeaders)
		},
		_processGetEntitiesCsvResponse(response, header) {
			response.then(responseData => {
				let entities = responseData[this.entitiesKey !== null ? this.entitiesKey : this.moduleName];
				this._createExportCsv(header, entities);
			});
		},
		getCsvHeaderFromSortingTableTitle(sortingTableTitles, skipProcessing = false) {
			let header = {};
			for (const title of sortingTableTitles) {
				let columnName = title.name;
				if(title.hasOwnProperty("skipInCsv") && title.skipInCsv){
					continue;
				}
				if(title.hasOwnProperty('column') && title.column.length > 0 && !skipProcessing) {
					let removedStartS = title.column.charAt(1).toLowerCase() + title.column.slice(2);
					columnName = removedStartS.split(/(?=[A-Z])/).join('_').toLowerCase();
				}else if(skipProcessing){
					columnName = title.column;
				}
				header[columnName] = {name: title.name};
			}

			return header;
		},
		resetFilter(){
			this.formFields = {...this.formFieldsDefaults};
			if(this.formFields.hasOwnProperty('sort')){
				this.saveSort(this.formFields.sort);
			}
		}
	},
}



// WEBPACK FOOTER //
// ./src/components/mixins/list-actions.js